/* eslint-disable prettier/prettier */
import { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { getUserInfo } from '@/shared/stores'

interface MenuProps {
  name: string
  link: string
  service?: string
  group?: string
  icon: string
  suffix?: string | ReactNode
  children?: MenuProps[]
  roles?: String[]
  code: string
}

const PORTAL_PREFIX = '/stream'

export const menu: MenuProps[] = [
  {
    icon: 'people_regular',
    service: 'stream',
    group: 'admin_user',
    name: 'title',
    link: `${PORTAL_PREFIX}/admin`,
    code: 'ADMIN_USER_MANAGEMENT',
    roles: ['admin'],
    children: [
      {
        icon: 'plug_disconnected_regular',
        service: 'stream',
        group: 'admin_user',
        name: 'admin_user_list',
        link: `${PORTAL_PREFIX}/admin`,
        code: 'ADMIN_USER_MANAGEMENT'
      },
      {
        icon: 'plug_disconnected_regular',
        service: 'stream',
        group: 'admin_user',
        name: 'organization',
        link: `${PORTAL_PREFIX}/admin/organization`,
        code: 'ORGANIZATION_MANAGEMENT'
      },
      {
        icon: 'plug_disconnected_regular',
        service: 'stream',
        group: 'admin_user',
        name: 'package',
        link: `${PORTAL_PREFIX}/admin/package`,
        code: 'PACKAGE_MANAGEMENT'
      }
    ]
  },
  {
    icon: 'teddy_regular',
    service: 'stream',
    group: 'user_management',
    name: 'title',
    link: `${PORTAL_PREFIX}/user`,
    code: 'USER_MANAGEMENT',
    roles: ['tck1']
  },
  {
    icon: 'teddy_regular',
    service: 'stream',
    group: 'campaign',
    name: 'title',
    link: `${PORTAL_PREFIX}/campaign`,
    code: 'CAMPAIGN_MANAGEMENT',
    roles: ['admin', 'tck1', 'tck2']
  },
  {
    icon: 'apps_list_regular',
    service: 'stream',
    group: 'scenario',
    name: 'title',
    link: `${PORTAL_PREFIX}/scenario`,
    code: 'SCENARIO_MANAGEMENT',
    roles: ['admin', 'tck1', 'tck2']
  },
  {
    icon: 'meet_now_regular',
    group: 'contact',
    service: 'stream',
    name: 'title',
    link: `${PORTAL_PREFIX}/contacts`,
    code: 'CONTACT_MANAGEMENT',
    roles: ['admin', 'tck1', 'tck2']
  },
  {
    icon: 'settings_regular',
    group: 'report',
    service: 'stream',
    name: 'title',
    link: `${PORTAL_PREFIX}/report`,
    code: 'REPORT_MANAGEMENT',
    roles: ['admin', 'tck1', 'tck2'],
    children: [
      {
        icon: 'plug_disconnected_regular',
        service: 'stream',
        group: 'report',
        name: 'outbound',
        link: `${PORTAL_PREFIX}/report`,
        code: 'PROVIDER_CREATE'
      },
      {
        icon: 'plug_disconnected_regular',
        service: 'stream',
        group: 'report',
        name: 'inbound',
        link: `${PORTAL_PREFIX}/report/inbound`,
        code: 'PROVIDER_INBOUND_MANAGEMENT'
      }
    ]
  },
  {
    icon: 'plug_disconnected_regular',
    group: 'provider',
    service: 'stream',
    name: 'title',
    link: `${PORTAL_PREFIX}/provider`,
    code: 'PROVIDER_MANAGEMENT',
    roles: ['admin', 'tck1', 'tck2'],
    children: [
      {
        icon: 'plug_disconnected_regular',
        service: 'stream',
        group: 'provider',
        name: 'outbound',
        link: `${PORTAL_PREFIX}/provider`,
        code: 'PROVIDER_CREATE'
      },
      {
        icon: 'plug_disconnected_regular',
        service: 'stream',
        group: 'provider',
        name: 'inbound',
        link: `${PORTAL_PREFIX}/provider/inbound`,
        code: 'PROVIDER_INBOUND_MANAGEMENT'
      }
    ]
  },
  {
    icon: 'call_connecting_regular',
    group: 'incall',
    service: 'stream',
    name: 'title',
    link: `${PORTAL_PREFIX}/incall`,
    code: 'INCALL_MANAGEMENT',
    roles: ['admin', 'tck1', 'tck2']
  },
  ,
  {
    icon: 'cart_regular',
    group: 'order',
    service: 'stream',
    name: 'title',
    link: `${PORTAL_PREFIX}/order`,
    code: 'ORDER_DETAIL_MANAGEMENT',
    roles: ['admin']
  },
]

export const getMenu = () => {
  const userInfo = useSelector(getUserInfo)
  const filterMenu = menu.filter((item) => {
    if (item.roles && item.roles.length > 0 && userInfo?.roles && userInfo?.roles.length > 0) {
      return item.roles.includes(userInfo?.roles[0] || '')
    }
    return false
  })
  return filterMenu
}
